import React from 'react';

export default class Notice extends React.Component {

  render() {
    return (
      <>
        <h2><strong>システム更新</strong></h2><br className="sp"/><h3>令和8年10月8日(木)</h3>
        <ul>
          <li>建築情報マップ（建築協定地区、団地認定）を令和8年9月15日現在に更新しました。</li>
          <li>宅地造成工事規制区域については、盛土規制法の運用開始に伴い令和7年5月19日より市全域が宅地造成等工事規制区域となりました。<br />
              本図では令和7年5月18日までの旧法での規制区域を表示していますので、ご注意ください。</li>
          <li>次回更新は令和8年12月下旬頃を予定しています。</li>
        </ul>
        <br />
      </>
    );
  }

}